/**
 * Programmatic entry point for the feedback form (D10-UI-002, #3604).
 *
 * The feedback form's state lives inside the header FeedbackButton, so other
 * surfaces (the help assistant's "Report a problem", and WP4's `open_feedback`
 * action, #3605) open it by dispatching this window event. The optional
 * payload pre-fills the form; the user still reviews and submits it.
 */
import type { FeedbackType } from "../../api/feedback";

export const OPEN_FEEDBACK_EVENT = "crm:open-feedback";

export interface OpenFeedbackPayload {
  type?: FeedbackType;
  /** Pre-filled description text (editable by the user). */
  description?: string;
}

export function openFeedback(payload: OpenFeedbackPayload = {}): void {
  window.dispatchEvent(
    new CustomEvent<OpenFeedbackPayload>(OPEN_FEEDBACK_EVENT, { detail: payload }),
  );
}

export function onOpenFeedback(cb: (payload: OpenFeedbackPayload) => void): () => void {
  const handler = (e: Event) => cb((e as CustomEvent<OpenFeedbackPayload>).detail ?? {});
  window.addEventListener(OPEN_FEEDBACK_EVENT, handler);
  return () => window.removeEventListener(OPEN_FEEDBACK_EVENT, handler);
}
